var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"pl-3 pt-1",attrs:{"value":_vm.selected_type,"items":_vm.types,"prepend-icon":"mdi-filter-outline","item-value":"code","item-text":"description","label":"Select type","dense":""},on:{"change":_vm.getSelection}})
}
var staticRenderFns = []

export { render, staticRenderFns }